import React, { useEffect, useState } from 'react';
import './ChartsDashboard.css';
import { Button, Row, Col, Typography } from 'antd';
import ChartSalesPastNMonths from './Balance/ChartSalesPastNMonths';
import ChartSalesPastNDays from './Balance/ChartSalesPastNDays';

type CumulativeSale = {
  date: string,
  totalUSD: number,
  totalEUR: number,
  total: number
};

interface Props {
  cumulativeSales?: CumulativeSale[],
  t: any
}
type ChartType = '3days' | '1week' | '1month' | '6months' | '1year';

export const ComulativeSales = (props: Props) => {
  const { Text } = Typography;
  const [chartTime, setChartTime] = useState<ChartType>('3days');
  const [cumulativeSales, setCumulativeSales] = useState<CumulativeSale[] | undefined>([]);

  useEffect(() => {
    setCumulativeSales(props.cumulativeSales);
  }, [props.cumulativeSales]);

  return <>
    <div className='titleBox'><Text className='titleBlackBox' >{props.t('CUMULATIVE_SALES')}</Text></div>
    <div className='boxActiveSensors'>
      <Row style={{ marginBottom: 20 }}>
        <Col style={{ height: '100%', marginTop: 5, marginLeft: 20 }}>
          <Text strong style={{ color: 'rgb(4, 39, 83)' }}>{props.t('BALANCE_HISTORY')}</Text></Col>
        <Col>
          <Button className={chartTime === '3days' ? 'activeBalanceButton' : 'balanceButton'}
            onClick={() => {
              setChartTime('3days');
            }}>3D</Button>
          <Button className={chartTime === '1week' ? 'activeBalanceButton' : 'balanceButton'}
            onClick={() => {
              setChartTime('1week');
            }
            } >1W</Button>
          <Button className={chartTime === '1month' ? 'activeBalanceButton' : 'balanceButton'}
            onClick={() => {
              setChartTime('1month');
            }}>1M</Button>
          <Button className={chartTime === '6months' ? 'activeBalanceButton' : 'balanceButton'}
            onClick={() => {
              setChartTime('6months');
            }}>6M</Button>
          <Button className={chartTime === '1year' ? 'activeBalanceButton' : 'balanceButton'}
            onClick={() => {
              setChartTime('1year');
            }}>1Y</Button>
        </Col>
      </Row>
      {
        chartTime === '3days' && cumulativeSales &&
        <ChartSalesPastNDays cumulativeSales={cumulativeSales} nDays={3}></ChartSalesPastNDays>
      }
      {
        chartTime === '1week' && cumulativeSales &&
        <ChartSalesPastNDays cumulativeSales={cumulativeSales} nDays={7}></ChartSalesPastNDays>
      }
      {
        chartTime === '1month' && cumulativeSales &&
        <ChartSalesPastNDays cumulativeSales={cumulativeSales} nDays={31}></ChartSalesPastNDays>
      }
      {
        chartTime === '6months' && cumulativeSales &&
        <ChartSalesPastNMonths cumulativeSales={cumulativeSales} nMonths={6}></ChartSalesPastNMonths>
      }
      {
        chartTime === '1year' && cumulativeSales &&
        <ChartSalesPastNMonths cumulativeSales={cumulativeSales} nMonths={12}></ChartSalesPastNMonths>
      }
    </div>

  </>;
};